import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { BrandVideoAPI } from '../../services/brandVideoAPI';


@inject(AuthService, UserMessageService, Router, BrandVideoAPI)
export class MyBrandVideoListCustomElement {
    constructor(authService, userMessageService, router, brandVideoAPI) {

        this.authService = authService;
        this.userMessageService = userMessageService;
        this.router = router;
        this.brandVideoAPI = brandVideoAPI;
        this.authorization = this.authService.getUser().token;
        this.video_src = "api/brandVideo/getProducedVideo/";
        this.submitted_src = "api/brandVideo/getSubmittedVideo/";
    }

    limitPages = [
        { id: 10, name: '10' },
        { id: 50, name: '50' },
        { id: 100, name: '100' },
      ];



    activate() {
        this.dataList = null;
        this.count = null;
        this.limit = 10;
        this.page = 1;
        this.sortBy = "CAPTURE_DATE";
        this.sortDir = "DESC";
        this.selectedlimitPages = 10;


        this.load();

    }

    detached() {
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
    }

    load(search='') {
        this.brandVideoAPI.getList(
            this.page,
            this.limit,
            this.sortBy,
            this.sortDir,
            1,
            search,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }


    saveLoadSuccess(data) {
        this.setData(data);
        // if(this.refreshTimeout)
        // {
        //     clearTimeout(this.refreshTimeout);
        //     this.refreshTimeout = null;
        // }
        // this.refreshTimeout = setTimeout(this.load.bind(this), 10000);

    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
    }

    setData(data) {
        this.dataList = data.list;
        console.log("Branded video count: "+data.count);
        this.count = data.count;
        this.pages =  Math.floor(this.count / this.limit);
        this.pages = this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;
    }

    rowClicked(item, $event) {
        console.log("item details...",item);
        this.router.navigate("video/brand/" + item.id);
        $event.stopPropagation();
    }

    delete(item, $event) {
        var sThisVal ='';
        var thisClass = this;
        $('.brand_delete:input[type=checkbox]').each(function () {
            sThisVal = (this.checked ? $(this).val() : "");
            console.log("check box value -->"+sThisVal);
            var item = {'id':sThisVal};
            if(sThisVal != "")
            {
                thisClass.brandVideoAPI.deleteTestimonial(
                        item,
                        thisClass.authService.getUser().token,
                        thisClass.deleteSuccess.bind(thisClass),
                        thisClass.saveLoadError.bind(thisClass));
            }
        });

        // $event.stopPropagation();
        // if(confirm("Delete this Brand Video?")) {
        //     this.brandVideoAPI.deleteTestimonial(
        //     item,
        //     this.authService.getUser().token,
        //     this.deleteSuccess.bind(this),
        //     this.saveLoadError.bind(this));
        // }
    }

    deleteSingle(id) {
      var thisClass = this;
      var item = {'id':id};

      if (confirm("Are you sure you want to delete video?")) {

        thisClass.brandVideoAPI.deleteTestimonial(
          item,
          thisClass.authService.getUser().token,
          thisClass.deleteSuccess.bind(thisClass),
          thisClass.saveLoadError.bind(thisClass));


        }

  }


    deleteSuccess(data) {
        this.load();
        setTimeout(() => {
          this.userMessageService.setUserMessage("user", "Video Successfully Deleted");
        }, 2000);

    }

    columnClicked(name) {
        if (this.sortBy == name) {
            if (this.sortDir == "ASC")
                this.sortDir = "DESC";
            else
                this.sortDir = "ASC";
            this.load();
        } else {
            this.sortBy = name;
            this.sortDir = "DESC";
            this.load();
        }
    }

    prev() {
        if (this.page > 1) {
            this.page--;
            this.dataList = null;
            this.load();
        }
    }

    next() {
        if (this.page < this.pages) {
            this.page++;
            this.dataList = null;
            this.load();
        }
    }

    limitChange() {
        if(this.limit != this.selectedlimitPages){
        this.limit = this.selectedlimitPages;
        this.dataList = null;
        this.load();
        }
      }

    isPublicChanged(item, $event) {

        $event.stopPropagation();

        this.brandVideoAPI.setPublic(
            item.id,
            !item.public,
            this.authService.getUser().token,
            (value) => {
                item.public = value;
                if(!value)
                    item.featured = false;
            },
            this.saveLoadError.bind(this));


    }

    isFeaturedChanged(item, $event) {

        $event.stopPropagation();
        this.brandVideoAPI.setFeatured(
            item.id,
            !item.featured,
            this.authService.getUser().token,
            (featured) => {item.featured = featured;},
            (error) => {item.featured = false; this.saveLoadError(error);});
    }

    download(id, $event) {

        window.open(this.video_src + id + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date(), "_blank");
        $event.stopPropagation();
    }

    downloadSubmittedvideo(id, $event)
    {
        window.open(this.submitted_src + id + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date(), "_blank");
        $event.stopPropagation();
    }

    showVideoClicked(id, $event) {
        this.videoPreviewPlayer.src = this.video_src + id + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
        this.showVideo = true;
        this.videoPreviewPlayer.play();
        $event.stopPropagation();
    }

    showVideoClosed($event) {
        this.showVideo = false;
        if (this.videoPreviewPlayer) {
            this.videoPreviewPlayer.pause();
        }
        $event.stopPropagation();
    }

    selectionCheckbox(control, $event){
        //console.log(control.checked);
        // if(control.checked)
        //     control.checked = false;
        // else
        //     control.checked = true;
        $event.stopPropagation();
    }

    stopEvent($event)
    {
        $('input:checked').click(function(e) {
            e.stopPropagation();
        });
    }

}
